module.exports = __webpack_public_path__ + "static/img/defender2.53db44b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cards/scoiatael/defender2.png
// module id = zo4R
// module chunks = 0